// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file types/v1/address.proto (package types.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * Address is a postal address used e.g. for registrations, billing and shipping.
 *
 * @generated from message types.v1.Address
 */
export const Address = /*@__PURE__*/ proto3.makeMessageType(
  "types.v1.Address",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "address_line1", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "address_line2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "locality", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "region_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "postal_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "country_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

